/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketTagResponse } from '../../models/ticket-tag-response';

export interface TicketControllerFindTicketTag$Params {
  id?: number;
  description?: string;
  active?: boolean;
  limit: number;
  skip: number;
  field?: 'description' | 'active';
  direction?: 'asc' | 'desc';
}

export function ticketControllerFindTicketTag(http: HttpClient, rootUrl: string, params: TicketControllerFindTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindTicketTag.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('description', params.description, {});
    rb.query('active', params.active, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketTagResponse;
      }>;
    })
  );
}

ticketControllerFindTicketTag.PATH = '/ticket/tag';
